import { makeStyles, shorthands, tokens } from '@fluentui/react-components';

export const getGenerationHistoryListStyles = makeStyles({
  paddleBtn: {
    ...shorthands.borderRadius('99px'),
    color: tokens.colorNeutralForeground2BrandHover,
    boxShadow: '0px 0.3px 0.9px rgba(0, 0, 0, 0.1), 0px 1.6px 3.6px rgba(0, 0, 0, 0.13)',
    marginRight: '2px',
  },
  paddleBtnRight: {
    ...shorthands.borderRadius('99px'),
    color: tokens.colorNeutralForeground2BrandHover,
    boxShadow: '0px 0.3px 0.9px rgba(0, 0, 0, 0.1), 0px 1.6px 3.6px rgba(0, 0, 0, 0.13)',
  },
  historyListRoot: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    alignSelf: 'stretch',
    marginTop: '24px',
    paddingTop: '16px',
    ...shorthands.borderTop('1px', 'solid', '#DFDFDF'),
    ...shorthands.overflow('hidden'),

    '& .history-list-title-container': {
      display: 'flex',
      flexDirection: 'row',
      marginBottom: '5px',
      alignItems: 'center',

      '& .history-icon': {
        display: 'flex',
        alignItems: 'center',
        width: '16px',
        height: '16px',
        color: tokens.colorNeutralForeground3,
      },
      '& .history-title': {
        marginLeft: '4px',
        fontSize: '14px',
        lineHeight: '20px',
        fontWeight: 600,
        color: tokens.colorNeutralForeground3,
      },
    },

    '& .history-list-container': {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      width: '100%',
      position: 'relative',
      '& .right-icon-hint': {
        display: 'inline-block',
        position: 'absolute',
        backgroundImage: 'linear-gradient(270deg, #FFFFFF 0%, rgba(255, 255, 255, 0.927755) 18.23%, rgba(255, 255, 255, 0.776042) 48.44%, rgba(250, 249, 255, 0.5) 78.24%, rgba(255, 255, 255, 0) 100%)',
        width: '20px',
        height: '80px',
        right: '32px',
      },

      '& .left-icon-hint': {
        display: 'inline-block',
        position: 'absolute',
        backgroundImage: 'linear-gradient(270deg, #FFFFFF 0%, rgba(255, 255, 255, 0.927755) 18.23%, rgba(255, 255, 255, 0.776042) 48.44%, rgba(250, 249, 255, 0.5) 78.24%, rgba(255, 255, 255, 0) 100%)',
        width: '30px',
        height: '80px',
        left: '34px',
        transform: 'rotate(-180deg)',
      },

      '& .history-list-images-container': {
        flexGrow: 1,
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        ...shorthands.overflow('hidden'),
        width: '100%',

        '& .history-list-images': {
          display: 'flex',
          flexWrap: 'wrap',
          flexDirection: 'row',
          alignItems: 'center',
          position: 'relative',
        },
        '& .history-item-root': {
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          width: '96px',
          height: '86px',
          ...shorthands.borderRadius('9px'),
          ...shorthands.border('2px', 'solid', 'white'),

          '&.selected': {
            ...shorthands.border('2px', 'solid', tokens.colorBrandForeground1),
          },

          '& .history-item': {
            width: '90px',
            height: '80px',
            ...shorthands.borderRadius('6px'),
            ...shorthands.overflow('hidden'),

            '& img': {
              width: '100%',
              height: '100%',
              objectFit: 'cover',
            },
          },
        },
      },
    },
  },
  historyListRootV2: {
    '& .history-list-container': {
      '& .history-images-view-less': {
        '& .view-less-image-container': {
          display: 'flex',
          flexDirection: 'row',
          flexWrap: 'wrap',
          rowGap: '12px',
          columnGap: '12px',
          width: '100%',

          '& .history-item-root': {
            ...shorthands.borderRadius('6px'),
            width: 'calc(50% - 6px)',
            aspectRatio: '1 / 1',
            cursor: 'pointer',
            ...shorthands.overflow('hidden'),

            '&.selected': {
              ...shorthands.border('2px', 'solid', tokens.colorBrandForeground1),
            },

            '& img': {
              width: '100%',
              height: '100%',
              objectFit: 'contain',
            },
          },
        },
        '& .view-all-button': {
          marginTop: '16px',
          width: '100%',
          ...shorthands.padding('2px', '0px'),
          fontSize: '12px',
          lineHeight: '20px',
          color: 'rgba(66, 66, 66, 1)',
        },
      },

      '& .history-images-view-all': {
        '& .view-all-image-container': {
          marginBottom: '28px',
          '& .prompt-title': {
            color: 'rgba(66, 66, 66, 1)',
            fontSize: '12px',
            marginBottom: '8px',
          },
          '& .view-all-list-box': {
            display: 'flex',
            flexDirection: 'row',
            flexWrap: 'wrap',
            rowGap: '12px',
            columnGap: '12px',
            width: '100%',

            '& .history-item-root': {
              ...shorthands.borderRadius('6px'),
              width: 'calc(50% - 6px)',
              aspectRatio: '1 / 1',
              cursor: 'pointer',
              ...shorthands.overflow('hidden'),

              '&.selected': {
                ...shorthands.border('2px', 'solid', tokens.colorBrandForeground1),
              },

              '& img': {
                width: '100%',
                height: '100%',
                objectFit: 'contain',
              },
            },
          },
        },
        '& .prompt-example-new': {
          marginTop: '0px',
          borderTop: '0px',
          '& .example-image-list-label': {
            marginTop: '0px !important',
            fontWeight: '600',
            fontSize: '14px',
            lineHeight: '19px',
            color: 'rgba(96, 94, 92, 1)',
            paddingButtom: '12px',
            paddingTop: '0px !important',
          },
        },
        '& .view-less-button': {
          marginTop: '16px',
          width: '100%',
          ...shorthands.padding('2px', '0px'),
          fontSize: '12px',
          lineHeight: '20px',
          color: 'rgba(66, 66, 66, 1)',
        },
      },
    },
  },
});
